import type { PasswordValidation, PasswordStrength } from "../../types/auth"

export const validatePassword = (password: string): PasswordValidation => {
  if (!password) {
    return {
      hasMinLength: false,
      hasUpperCase: false,
      hasLowerCase: false,
      hasNumber: false,
      hasSpecialChar: false,
    }
  }

  return {
    hasMinLength: password.length >= 8,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /[0-9]/.test(password),
    hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
  }
}

export const getPasswordStrength = (validation: PasswordValidation): PasswordStrength => {
  if (!validation) return null

  const validCount = Object.values(validation).filter(Boolean).length

  if (validCount <= 2) {
    return "weak"
  } else if (validCount <= 4) {
    return "medium"
  } else {
    return "strong"
  }
}

export const getPasswordStrengthColor = (strength: PasswordStrength): string => {
  switch (strength) {
    case "weak":
      return "text-red-500"
    case "medium":
      return "text-yellow-500"
    case "strong":
      return "text-green-500"
    default:
      return "text-gray-400"
  }
}

